import { endpoints, request } from '#services'
import { GetPageError, GetPostError } from '#errors'

/**
 * Fetch a page from the WordPress REST API.
 * @param {number} id - The page ID.
 * @returns {Promise<object>} The page data from the API.
 */
export const getPage = async (id) => {
  try {
    return await request(endpoints.pages.get(id))
  } catch (error) {
    throw GetPageError(error)
  }
}

/**
 * Fetch a post from the WordPress REST API.
 * @param {number} id - The post ID.
 * @returns {Promise<object>} The post data from the API.
 */
export const getPost = async (id) => {
  try {
    return await request(endpoints.posts.get(id))
  } catch (error) {
    throw GetPostError(error)
  }
}

/**
 * Fetch a post by slug using the WordPress REST API (pages endpoint).
 * @param {string} slug - The post slug.
 * @returns {Promise<object>} The post data from the API.
 */
export const getPostThroughSlug = async (slug) => {
  try {
    return await request({ ...endpoints.pages.get(), ...{ params: { slug } } })
  } catch (error) {
    throw GetPostError(error)
  }
}

/**
 * Fetch a page by slug using the WordPress REST API (posts endpoint).
 * @param {string} slug - The page slug.
 * @returns {Promise<object>} The page data from the API.
 */
export const getPageThroughSlug = async (slug) => {
  try {
    return await request({ ...endpoints.posts.get(), ...{ params: { slug } } })
  } catch (error) {
    throw GetPageError(error)
  }
}
